import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let PaginationComp;

class Pagination extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: PaginationComp };
      }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/pagination-comp" */
            "../../../components/javascript/zcat-components/pagination-comp"
        ).then(function(res) {
            PaginationComp = res.PaginationComp;
        }));

        
;
    }
}

export {Pagination};

